module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "calibre3"
  }, [_vm._v("Erster Akt")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Moskau. Tschernavayastraße 99. Eine geräumige\nDachstube, durch Öllampen erhellt, die von der Decke herabhängen.\nMehrere maskierte Männer, schweigend und in einer gewissen\nEntfernung voneinander. Ein Mann in scharlachroter Maske sitzt\nschreibend an einem Tische. Eine Tür im Hintergrunde. Vor ihr ein\nMann in gelbem Gewand mit gezücktem Schwert. Es klopft. Maskierte\nMänner, in Mäntel gehüllt, treten ein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Losung")]), _vm._v(": "), _c('span', {
    staticClass: "teletype"
  }, [_vm._v("Per\ncrucem ad lucem.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Antwort")]), _vm._v(": "), _c('span', {
    staticClass: "teletype"
  }, [_vm._v("Per\nsanguinem ad libertatem.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Eine Uhr schlägt. Die Verschwörer bilden\neinen Halbkreis in der Mitte der Bühne.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(": Wie lautet das Wort?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Erster Verschwörer")]), _vm._v(": Rabat.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(": Die Antwort?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Zweiter Verschwörer")]), _vm._v(": Kalit.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(": Welche Stunde zählen\nwir?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Dritter Verschwörer")]), _vm._v(": Die Stunde des\nLeidens.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(": Welchen Tag?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vierter Verschwörer")]), _vm._v(": Den Tag der\nUnterdrückung.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(": Welches Jahr?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Fünfter Verschwörer")]), _vm._v(": Das neunte\nseit der französischen Revolution.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(": Wieviel sind wir an\nZahl?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sechster Verschwörer")]), _vm._v(": Zehn, neun\nund drei.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(": Der Nazarener hatte\nnicht so viel und hat die Welt erobert. Was ist es, was wir\nwollen?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Siebenter Verschwörer")]), _vm._v(": Freiheit\nschaffen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(": Unser Evangelium?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Achter Verschwörer")]), _vm._v(":\nVernichtung.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(": Unsre Pflicht?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Neunter Verschwörer")]), _vm._v(": Gehorsam.\n"), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page15",
      "title": "divisi/a41b"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(": Brüder, die Fragen haben\ngute Antwort gefunden. Nur Nihilisten sind in unserer Mitte. Wir\nwollen uns gegenseitig ins Gesicht blicken. ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Die Verschwörer demaskieren sich.")]), _vm._v(") Michael, leiste\nden Eid!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Wir schwören! zu morden,\nwas noch Natur in uns ist. Nicht Liebe zu geben, nicht Liebe zu\nnehmen. Mitleid weder dir noch mir. Nicht Brautstand, nicht\nHochzeit, bis das Ende gekommen. Wir schwören, heimlich bei Nacht\nzu meucheln, Gift ins Glas zu gießen, Vater gegen Sohn, Mann gegen\nWeib zu hetzen. Wir schwören ohne Zagen, ohne Hoffnung, ohne Ende\nzu leiden, zu vernichten, zu rächen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(": Sind wir alle einig?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Die Verschwörer")]), _vm._v(": Wir sind's. (\n"), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Sie zerstreuen sich in verschiedenen Richtungen\nüber die Bühne.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(": Die Stunde ist vorüber,\nMichael, und sie ist noch nicht da.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Ich wollt', sie wäre hier.\nWir können ohne sie wenig anfangen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": Sie kann doch nicht gefaßt\nworden sein, Präsident? Die Polizei ist ihr auf der Spur, ich weiß\nes.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Du scheinst immer recht\nviel von dem zu wissen, was bei der Moskauer Polizei vorgeht. Zu\nviel für einen ehrlichen Verschwörer.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(": Wenn die Hunde sie\ngefangen haben, soll die rote Fahne der Revolution auf allen\nStraßen von den Barrikaden wehen, bis wir sie gefunden haben. Es\nwar auch Wahnsinn von ihr, auf den Ball des Großfürsten zu gehen.\nIch habe sie gewarnt, aber sie sagte, sie müsse den Zar und die\nganze Satansbrut einmal von Angesicht zu Angesicht sehn.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": Auf dem Hofball? "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page16",
      "title": "divisi/a41b"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Ich habe keine Angst. Sie\nist so schwer zu fangen wie eine Wölfin, und doppelt so gefährlich.\nDann ist sie auch gut verkleidet. Doch gibt's etwas Neues im\nSchloß, Präsident? Was treibt der Bluthund jetzt, außer seinen\neinzigen Sohn zu martern? Hat einer von euch den Prinzen gesehen?\nMan hört sonderbare Geschichten von ihm. Es heißt, er liebt das\nVolk, aber ein Königssohn hat das noch nie getan. Das läßt sich\nnicht anerziehen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(": Seit einem Jahr ist er\nvom Ausland zurück, und seitdem hält ihn sein Vater im Schloß in\nstrengem Gewahrsam.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Eine prächtige Art, ihn\nzum Tyrannen zu machen. Doch gibt's Neuigkeiten, frag' ich?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(": Eine Konferenz soll\nmorgen um vier Uhr stattfinden. Der Gegenstand ist geheim, die\nSpäher können nicht dahinterkommen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Wenn eine Konferenz in\neinem Königsschlosse stattfindet, so handelt sich's gewiß um\nirgendeine blutige Tat. In welchem Zimmer wird die Konferenz\nabgehalten?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(" ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("aus\neinem Briefe lesend")]), _vm._v("): Im gelben Gobelinsaal, der nach der\nKaiserin Katharina benannt ist.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Ich geb' nichts auf\nschönklingende Namen. Ich möchte wissen, wo er liegt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(": Ich kann dir's nicht\nsagen, Michael. Ich kenne mich im Innern von Gefängnissen besser\naus als in Palästen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(" ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("sich\nplötzlich an Alexis wendend")]), _vm._v("): Wo liegt der Saal, Alexis?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": Im ersten Stock, mit der\nAussicht in den Lichthof. Aber warum fragst du, Michael?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Ah, nichts, nichts, mein\nJunge. Ich interessiere mich nur lebhaft für das Leben und das Tun\ndes Zaren, und ich hab' gewußt, daß du mir genau Auskunft über\n"), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page17",
      "title": "divisi/KaFa"
    }
  }), _vm._v(" das Schloß\ngeben kannst. Natürlich kennt sich jeder verhungerte Mediziner in\nMoskau in königlichen Schlössern aus. Das bringt wohl euer Beruf\nmit sich, nicht wahr?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(" ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("beiseite")]), _vm._v("): Sollte Michael Verdacht gegen mich haben?\nEtwas Seltsames ist heute in seinem Wesen. Warum kommt sie nicht?\nDie ganze Glut der Revolution scheint in graue Asche zu zerfallen,\nwenn sie nicht da ist.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Hast du in letzter Zeit\nviele Kranke in deinem Spital kuriert?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": Einer liegt zu Tode\ndarnieder, den ich gerne heilen würde, doch ich vermag's nicht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": So, und wer wäre das?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": Rußland, unsere Mutter.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Die Heilung Rußlands muß\nder Chirurg besorgen – dazu ist das Messer nötig. Ich halte nichts\nvon deiner Heilmethode.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(": Professor, wir haben die\nAbzüge deines letzten Aufrufs gelesen. Er ist wirklich gut.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Worüber handelt er,\nProfessor?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Professor")]), _vm._v(": Das Thema, lieber\nBruder, lautet: »Der Mord als ein Mittel der politischen\nReform.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Bei Revolutionen geb' ich\nwenig auf Feder und Tinte. Ein Dolch richtet mehr aus als hundert\nEpigramme. Wir wollen aber doch die letzte Leistung dieses\nGelehrten lesen. Reicht sie mir. Ich will sie vorlesen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Professor")]), _vm._v(": Bruder, du liest immer\nüber die Punkte weg. Laß es lieber Alexis vorlesen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Jawohl, er hat eine so\ngeschmierte Zunge wie nur irgendein junger Aristokrat. Ich für\nmeine Person geb' nichts auf Punkte, wenn nur der Sinn richtig\nist.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(" ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("lesend")]), _vm._v("): »Die Vergangenheit hat dem Tyrannen gehört,\ner hat sie besudelt. Uns gehört die Zukunft, wir "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page18",
      "title": "a41b/KaFa"
    }
  }), _vm._v(" wollen sie heiligen.« Wohlan,\nwir wollen die Zukunft heiligen. Wenigstens "), _c('em', {
    staticClass: "calibre10"
  }, [_vm._v("eine")]), _vm._v("\nRevolution soll's geben, die nicht im Verbrechen gezeugt, nicht mit\nMord genährt ist.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Mit dem Schwert haben sie\nzu uns gesprochen, mit dem Schwert wollen wir antworten! Du bist zu\nzart für uns, Alexis. Hier sollten nur Männer sein, deren Hände von\nArbeit rauh oder rot vom Blute sind.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(": Ruhe, Michael, Ruhe! Er\nhat das mutigste Herz von uns allen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("Michael ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("beiseite")]), _vm._v("): Heute nacht wird\ner seinen Mut brauchen können. ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Man hört\ndraußen das Schellengeklingel eines Schlittens.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Eine Stimme von außen")]), _vm._v(": "), _c('span', {
    staticClass: "teletype"
  }, [_vm._v("Per crucem ad lucem")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Antwort der Wache")]), _vm._v(": "), _c('span', {
    staticClass: "teletype"
  }, [_vm._v("Per sanguinem ad libertatem")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Wer ist's?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Gott schütze das Volk!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(": Willkommen, Vera,\nwillkommen! Unser Herz war schwer, weil wir dich nicht sahen. Doch\nnun ist mir's, als sei der Stern der Freiheit aufgegangen, um uns\nin unsrer Nacht zu leuchten. Was bringst du Neues?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Nacht ist es auch, mein\nBruder! Nacht ohne Mond und Sterne! Rußland ist ins Herz getroffen!\nIwan, den man den Zaren nennt, zückt jetzt nach unserer Mutter\neinen Dolch, der schärfer ist als irgendeiner, den die Tyrannei je\ngegen das Leben des Volkes geschmiedet hat.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Was hat der Tyrann schon\nwieder getan?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Das Standrecht wird morgen in\nRußland verkündet.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alle")]), _vm._v(": Das Standrecht! Wir sind\nverloren! Wir sind verloren!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": Das Standrecht!\nUnmöglich!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Narr, in Rußland ist alles\nmöglich, nur nicht Reformen. "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page19",
      "title": "a41b/KaFa"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Ja, das Standrecht! Das\nletzte Recht, an das sich das Volk geklammert hat, wird ihm\ngenommen. Ohne verhört, ohne gerichtet, sogar ohne angeklagt zu\nwerden, sollen unsere Brüder aus ihren Häusern geschleppt, in den\nStraßen wie Hunde erschossen, sollen sie verbannt werden, um im\nSchnee zu sterben, im Kerker zu verschmachten, in den Bergwerken zu\nfaulen. Wißt ihr, was das Standrecht bedeutet? Es bedeutet die\nErdrosselung einer ganzen Nation. Auf den Straßen wird es Tag und\nNacht von Soldaten wimmeln; an jeder Türe wird ein Posten stehen.\nNiemand darf sich auf die Straße wagen, wenn er nicht ein Spion\noder Verräter ist. Wenn wir uns in Höhlen verkriechen müssen, um\nuns zu verbergen, wenn wir nur verstohlen zusammenkommen, mit\nverhaltenem Atem sprechen dürfen: wie sollen wir Rußland dann noch\nnützen?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(": Leiden können wir\nwenigstens.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Das haben wir mehr als genug\ngetan. Jetzt hat die Stunde der Zerstörung und der Rache\ngeschlagen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(": Bis jetzt hat sich das\nVolk alles bieten lassen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Weil's ihm bisher an Verstand\ngefehlt hat. Wir aber, die Nihilisten, haben ihm jetzt vom Baume\nder Erkenntnis zu essen gegeben, und der Tag des stummen Leidens\nist für Rußland vorbei.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Das Standrecht, Vera! Eine\nentsetzliche Nachricht, die du da bringst.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(": Es ist der Totenschein\nder Freiheit Rußlands.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Oder die Sturmglocke der\nRevolution.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Ist es auch sicher\nwahr?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Hier ist der Erlaß. Ich hab'\nihn heut nacht einem jungen Gecken auf dem Ball gestohlen, einem\nder Sekretäre des Prinzen Paul, der ihn zum Abschreiben bekommen\nhatte. Dadurch habe ich mich verspätet. ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Vera\ngibt den Erlaß Michael, der ihn liest.")]), _vm._v(") "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page20",
      "title": "a41b/KaFa"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": »Zur Sicherung des\nöffentlichen Wohles – Standrecht. Im Auftrage des Zaren, des Vaters\nseines Volkes.« Vater seines Volkes!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Ja! Ein Vater, dessen Name\nnicht geheiligt ist, dessen Reich eine Republik werden, dessen\nSchuld nicht vergeben werden soll, weil er uns unser täglich Brot\ngenommen hat. Sein ist nicht die Kraft und die Herrlichkeit, weder\njetzt noch in Ewigkeit.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(": Es muß sich bei der\nKonferenz, die morgen zusammentritt, um das Standrecht handeln. Der\nErlaß ist bis jetzt noch nicht unterschrieben.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": Das soll auch nicht\ngeschehen, solange ich noch meine Zunge habe, um zu\nprotestieren.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Und ich meine Hände zum\nDreinschlagen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Das Standrecht! Du guter\nGott, wie leicht hat es ein König, sein Volk zu Tausenden\nhinzumorden – wir aber können uns nicht von einem einzigen derer,\ndie Europas Kronen tragen, freimachen. Worin besteht denn die\nerhabene Majestät dieser Männer, daß die Hand unsicher wird, der\nDolch versagt, der Schuß sein Ziel verfehlt? Sind es nicht Menschen\nmit denselben Leidenschaften wie wir, die den gleichen Krankheiten\nausgesetzt, von gleichem Fleisch und Blut sind, wie wir? Was ließ\nOlgiati erzittern, als es zum großen Augenblick im Leben dieses\nRömers kam, was machte Guidos Nerven in jenem Augenblick versagen,\nwo er von Stahl und Eisen hätte sein sollen? Die Pest, sage ich,\nauf die Schwächlinge in Neapel, Berlin und Madrid! Ich dächte, wenn\nich einem Gekrönten gegenüberstünde, würde mein Auge klarer sehen,\nmein Ziel mir deutlicher vorschweben, mein ganzer Körper Kraft und\nStärke finden wie nie zuvor! Bedenkt, was sich zwischen uns und die\nFreiheit Europas drängt! Ein paar alte Männer, verrunzelte,\nwackelnde, zittrige "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page21",
      "title": "a41b/adelheidis"
    }
  }), _vm._v(" Greise, die ein Kind um einen Dukaten\nerwürgen, ein Weib bei Nacht niedermachen könnte. Und das steht\nzwischen uns und der Demokratie, zwischen uns und der Freiheit.\nAber jetzt, scheint mir, sind die Männer ausgestorben, und die\nschwerfällige Erde hat das viele Gebären über – sonst würde kein\ngekrönter Hund mehr leben und Gottes Luft verpesten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alle")]), _vm._v(" ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("durcheinander")]), _vm._v("): Versuch's mit uns!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Auch du, Vera, wirst eines\nTages die Probe zu bestehen haben.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Das gebe Gott! Hab' ich nicht\ngemordet, was noch Natur in mir ist, und werd' ich meinen Schwur\nnicht halten?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(" ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("zum\nPräsidenten")]), _vm._v("): Das Standrecht, Präsident! Jetzt ist keine\nZeit mehr zu verlieren. Wir haben noch zwölf Stunden vor uns, ehe\nder Kronrat zusammentritt. Zwölf Stunden! Man kann eine Dynastie in\nkürzerer Zeit entthronen!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(": Jawohl, und auch um\neinen Kopf kürzer werden. ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Michael und der\nPräsident ziehen sich in eine Ecke zurück und sitzen flüsternd\nbeisammen. Vera hebt den Erlaß auf und liest ihn für sich. Alexis\nbeobachtet sie und eilt plötzlich auf sie zu.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": Vera!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Alexis, du hier? Törichter\nKnabe, hab' ich dich nicht gebeten, fortzubleiben? Wir alle hier\nsind bestimmt, vor unserer Zeit zu sterben, vom Schicksal dazu\nausersehen, das Gute, das wir tun, mit Foltern zu sühnen. Du aber,\nmit deinem strahlenden Jünglingsgesicht, du bist zu jung, schon zu\nsterben.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": Niemand ist zu jung, für\nsein Vaterland zu sterben!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Warum kommst du Nacht für\nNacht hierher?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": Weil ich mein Volk liebe.\n"), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page22",
      "title": "a41b/adelheidis"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Deine Kameraden müssen dich\naber doch vermissen? Gibt es keine Verräter unter ihnen? Du weißt,\nwie viele Spione hier auf der Universität sind. Alexis, du mußt\nfort. Du siehst, wie verzweifelt uns das Leid gemacht hat. Hier ist\nnicht Platz für eine Natur wie deine. Du darfst nicht\nwiederkommen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": Warum denkst du so gering\nvon mir? Warum soll ich leben, wenn meine Brüder leiden?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Du hast einmal von deiner\nMutter mit mir gesprochen. Du sagtest, daß du sie liebst. Denk an\n"), _c('em', {
    staticClass: "calibre10"
  }, [_vm._v("sie")]), _vm._v("!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": Ich habe jetzt keine Mutter\naußer Rußland. Mein Leben gehört ihr – mag sie's behalten oder\nverschenken. Doch heute bin ich hier, um dich zu sehen. Es heißt,\ndu gingst morgen nach Nowgorod.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Ich muß. Sie werden dort\nverzagt, und ich möchte die Flamme der Revolution zu solcher Lohe\nanfachen, daß die Augen aller Herrscher in Europa davon geblendet\nwerden sollen. Wenn das Standrecht verhängt wird, brauchen sie mich\ndort doppelt. Die Tyrannei eines Menschen scheint kein Ende zu\nfinden – aber die Leiden eines ganzen Volkes sollen ihr Ende\nfinden.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": Gott weiß es, ich bin auf\nEurer Seite. Doch du darfst nicht reisen. Die Polizei fahndet nach\ndir in jedem Zug. Wenn man dich faßt, sollst du ohne Verhör ins\ntiefste Verlies des Palastes geworfen werden. Ich weiß es –\ngleichviel woher. Oh, denke daran, wie mit dir die Sonne aus\nunserem Leben schwindet – wie das Volk seinen Führer, die Freiheit\nihre Priesterin verliert. – Vera, du darfst nicht gehen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Wenn du es wünschest, will\nich bleiben. Ich möchte noch länger für die Freiheit, noch länger\nfür Rußland leben.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": Wenn du fällst, dann ist\nRußland verloren – wenn du fällst, dann verläßt mich jede Hoffnung\n– "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page23",
      "title": "a41b/adelheidis"
    }
  }), _vm._v("\njede … Vera, eine schreckliche Nachricht bringst du da – das\nStandrecht – es ist zu furchtbar. Ich hab' es nicht gewußt – bei\nmeiner Seligkeit, ich hab' es nicht gewußt!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Wie hättest du es auch wissen\nkönnen? Dafür ist es ein viel zu schlau angelegtes Komplott. Der\ngewaltige weiße Zar, dessen Hände rot sind vom Blute des Volkes,\ndas er gemordet hat, dessen Seele schwarz ist von Niedertracht, er\nist der abgefeimteste Verschwörer unter uns allen. Wie kann es in\nRußland zwei so verschiedene Herzen geben, wie deines und\nseines!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": Vera, der Kaiser war nicht\nimmer so wie jetzt. Es gab eine Zeit, da hat er das Volk geliebt.\nDer Satan – Gott verdamm' ihn! – Fürst Paul Maraloffski hat ihn so\nweit gebracht. Morgen, ich schwör' es dir, will ich für das Volk\nzum Zaren sprechen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Du willst zum Zaren sprechen?\nToller Knabe, nur die zum Tode Verurteilten bekommen je den Zaren\nzu sehen. Und dann – was gibt er auf eine Stimme, die um Gnade\nfleht? Der Todesschrei eines Riesenvogels hat sein steinernes Herz\nnicht bewegt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(" ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("für\nsich")]), _vm._v("): Und dennoch will ich zu ihm sprechen. Man kann mich\nhöchstens töten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Professor")]), _vm._v(": Hier sind die\nProklamationen, Vera. Glaubst du, daß sie ihren Zweck erfüllen?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Ich werde sie lesen. Wie\nschön er ist! Er hat noch nie so vornehm ausgesehen wie heute\nnacht. Gesegnet ist die Freiheit, für die ein solcher Mann\nerglüht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": Nun, Präsident, womit seid\nIhr so beschäftigt?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Wir denken nur über die\nbeste Art nach, wie man Bären schießt. ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Flüstert mit dem Präsidenten und führt ihn\nbeiseite.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Professor")]), _vm._v(" ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("zu\nVera")]), _vm._v("): Und welche Antwort sollen wir unseren Brüdern in\nParis und Berlin auf ihre Briefe geben? "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page24",
      "title": "a41b/adelheidis"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(" ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("nimmt\ndie Briefe mechanisch")]), _vm._v("): Hätte ich nicht geschworen, nicht\nLiebe zu geben, nicht Liebe zu nehmen, ich glaube, ich hätte ihn\ngeliebt. Oh, ich bin wahnsinnig, bin selbst eine Verräterin – eine\nVerräterin! Doch warum kam er auch zu uns mit einem frischen,\njungen Gesicht, seinem freiheitsentflammten Herzen, seiner reinen,\nweißen Seele! Warum erzeugt er manchmal in mir den Wunsch, ihn zum\nHerrn und König zu haben, in mir, die ich Republikanerin bin? Oh,\nNärrin, dreimal Närrin! Verräterin an deinem Eide! Schwankender als\nWasser! Mach' ein Ende! Denk daran, was du bist – eine Nihilistin,\neine Nihilistin!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(" ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("zu\nMichael")]), _vm._v("): Man wird dich festnehmen, Michael.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Ich glaube nicht. Ich will\ndie Uniform der kaiserlichen Garde anlegen, und der wachthabende\nOberst ist einer der unseren. Das Zimmer liegt im ersten Stock, du\nerinnerst dich – ich kann also einen wohlgezielten Schuß\nabgeben.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(": Soll ich unsern Brüdern\netwas davon sagen?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Kein Wort davon, kein\nWort! Ein Verräter ist unter uns.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Ist das die Proklamation?\nJawohl, sie wird ihren Zweck erfüllen. Schickt fünfhundert Nummern\nnach Kiew, Odessa und Nowgorod, fünfhundert nach Warschau, und laßt\ndie doppelte Zahl in den südlichen Gouvernements verteilen. Die\nschwerfälligen russischen Bauern kümmern sich allerdings wenig um\nunsere Proklamation und noch weniger um unsere Leiden. Wenn der\nSchlag geführt wird, muß es von der Stadt und nicht vom Lande aus\ngeschehen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": So ist's – und mit dem\nSchwert, nicht mit dem Federkiel.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Wo sind die Briefe aus\nPolen?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Professor")]), _vm._v(": Hier! "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page25",
      "title": "a41b/adelheidis"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Unglückliches Polen! Die\nAdler Rußlands haben dir am Herzen gezehrt. Wir dürfen unsere\nBrüder dort nicht vergessen. –")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(": Ist das wahr, was du da\nsagst, Michael?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Jawohl, ich verwette\nmeinen Kopf dafür!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(": So laßt die Türen\nschließen. Alexis Iwantschiewitsch ist unsrer Brüderschaft als\nStudent der Medizin an der Universität Moskau beigetreten. Warum\nhast du uns nichts von dem Blutplan erzählt, daß das Standrecht\nverhängt werden soll?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": Ich, Präsident?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Ja, du! Du hast davon\ngewußt – mehr als alle anderen. Waffen wie die werden nicht an\neinem Tag geschmiedet. Warum hast du uns nichts davon gesagt? Noch\nvor einer Woche wäre Zeit gewesen, Minen zu legen, Barrikaden zu\nbauen, zum mindesten einen Streich für die Freiheit zu führen. Doch\njetzt ist die Stunde verpaßt. Es ist zu spät, zu spät! Warum hast\ndu vor uns ein Geheimnis daraus gemacht, frage ich?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": Bei der Hand der Freiheit,\ndu verleumdest mich, Michael, mein Bruder. Ich wußte nichts von\ndiesem scheußlichen Erlaß. Bei meinem Seelenheil, Brüder, ich wußte\nnichts davon. Wie hätte ich auch sollen?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Weil du ein Verräter bist!\nWohin bist du von hier nach unserer letzten nächtlichen Versammlung\ngegangen?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": In meine Wohnung,\nMichael.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Lügner! Ich war dir auf\nden Fersen. Du gingst von hier um ein Uhr nachts fort. In einen\nweiten Mantel eingehüllt, hast du über den Fluß gesetzt, eine Meile\nunterhalb der zweiten Brücke, und hast dem Bootsmann ein Goldstück\ngegeben, du, der arme Student der Medizin! Zweimal bist du\nzurückgegangen und hast dich unter "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page26",
      "title": "a41b/adelheidis"
    }
  }), _vm._v(" einem Torbogen versteckt – so lange,\ndaß ich fast drauf und dran war, dich niederzumachen, wenn ich\nnicht so sehr aufs Jagen erpicht wäre. Du dachtest wohl, jede\nVerfolgung unmöglich gemacht zu haben, nicht wahr? Schwachkopf! Ich\nbin ein Bluthund, der seine Spur nie verliert. Ich bin dir von\nStraße zu Straße gefolgt. Endlich bemerkte ich, wie du eilig über\nden Sankt-Isaaks-Platz gingst, der Wache das geheime Losungswort\nzurauntest und durch eine Nebentüre, zu der du einen Schlüssel\nhattest, in den Palast tratst.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Die Verschwörer")]), _vm._v(": In den Palast!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Alexis!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Ich wartete weiter. All\ndie öden Stunden der langen russischen Nacht hab' ich gewartet.\nTöten wollt' ich dich, wenn du mit dem Judaslohn in der Hand\nherauskämst. Doch du bist nicht mehr herausgekommen. Du hast den\nPalast nicht mehr verlassen. Ich sah die Sonne durch den braunen\nNebel blutigrot über der düstern Stadt aufgehen – sah einen neuen\nTag der Unterdrückung für Rußland kommen. Doch du bist nicht mehr\nherausgekommen. Du verbringst also ganze Nächte im Schloß? Du\nkennst das Losungswort für die Wache! Du hast einen Schlüssel zu\neiner Nebentür? Pfui, ein Spion bist du – ein Spion! Ich hab' dir\nnie getraut, dir mit deinen weichen, weißen Händen, deinem\nLockenhaar, deinem Mädchengesicht. Du hast nicht eine Spur\nerlittener Qualen an dir; du kannst es nicht mit dem Volk halten.\nEin Spion bist du – ein Spion – ein Verräter!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alle")]), _vm._v(" ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("durcheinander")]), _vm._v("): Nieder mit ihm! Nieder mit ihm! (\n"), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Ziehen ihre Dolche.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(" ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("sich vor\nAlexis werfend")]), _vm._v("): Zurück, Michael! Zurück mit euch allen!\nWagt nicht, Hand an ihn zu legen! Er ist der Beste von uns allen.\n"), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page27",
      "title": "a41b/adelheidis"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alle")]), _vm._v(": Nieder mit ihm! Nieder mit\nihm! Er ist ein Spion!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Wagt ihn anzurühren, und ich\nlasse euch alle miteinander im Stich.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(": Vera, hast du nicht\ngehört, was Michael von ihm berichtet hat? Er hat die ganze Nacht\nim Zarenschloß zugebracht. Er kennt das Losungswort – hat einen\nGeheimschlüssel. Was kann er anderes sein als ein Spion?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Pah! Ich glaube Michael\nnicht. Es ist nur Lüge – nur Lüge! Alexis, sag', daß es gelogen\nist!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": Es ist wahr. Michael hat\nnur erzählt, was er wirklich gesehen hat. Ich bin nachts ins\nZarenschloß gegangen. Michael hat die Wahrheit gesagt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Zurück, sag' ich, zurück!\nAlexis, mir liegt nichts daran. Ich traue dir. Du könntest uns\nnicht verraten – nicht das Volk für Geld verkaufen. Du meinst es\nehrlich und treu! Sag', daß du kein Spion bist!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": Spion? Du weißt, daß ich's\nnicht bin. Ich gehöre euch, meine Brüder, bis zum Tode!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Du meinst bis zu deinem\nTod.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": Vera, du weißt, daß ich\ntreu bin.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Ich weiß es.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(": Warum bist du\nhergekommen, Verräter?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": Weil ich das Volk\nliebe.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Dann kannst du auch ein\nMärtyrer fürs Volk werden!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Erst mußt du mich töten,\nMichael, ehe du ihn auch nur mit dem Finger berührst.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(": Michael, wir dürfen Vera\nnicht verlieren. Es ist nun einmal ihre Laune, dem Burschen das\nLeben zu retten. Wir können ihn hier über Nacht behalten. Vorher\nhat er uns ja noch nicht verraten. ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Auf dem\nGang Schritte von Soldaten, es wird an die Tür geklopft.")]), _vm._v(")\n"), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page28",
      "title": "a41b/adelheidis"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Eine Stimme")]), _vm._v(": Öffnet, im Namen des\nKaisers!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Er "), _c('em', {
    staticClass: "calibre10"
  }, [_vm._v("hat")]), _vm._v(" uns\nverraten! Das ist dein Werk, Spion!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(": Ruhig, Michael, ruhig!\nWir haben keine Zeit, uns den Hals abzuschneiden, wenn es gilt,\nunseren Kopf zu retten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Die Stimme")]), _vm._v(": Öffnet im Namen des\nKaisers!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(": Brüder, nehmt alle die\nLarven vor. Michael, öffne die Tür. Es bleibt uns keine Wahl. (\n"), _c('span', {
    staticClass: "regie"
  }, [_vm._v("General Kotemkin und Soldaten treten\nein.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("General")]), _vm._v(": Alle guten Bürger haben\neine Stunde vor Mitternacht in ihrem Haus zu sein, und nicht mehr\nals fünf Leute haben das Recht, zusammenzukommen. Kennt ihr die\nBekanntmachung nicht, Kerle?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Ja. Ihr habt doch jede\nanständige Mauer in Moskau damit vollgeschmiert.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Ruhe, Michael, Ruhe. Nein,\nHerr, wir kennen die Bekanntmachung nicht. Wir sind eine wandernde\nSchauspielertruppe – auf dem Wege von Samara nach Moskau, um Seine\nkaiserliche Hoheit, den Zaren, zu belustigen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("General")]), _vm._v(": Aber ich habe lärmende\nStimmen gehört, bevor ich hereinkam. Was hatte das zu bedeuten?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Wir haben ein neues\nTrauerspiel geprobt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("General")]), _vm._v(": Eure Antworten klingen mir\nzu ehrlich, als daß sie wahr wären. Laßt sehen, wer ihr seid. Herab\nmit diesen Gauklermasken. Beim heiligen Nikolaus, mein nettes Kind,\nwenn dein Gesicht so hübsch ist, wie deine Gestalt, so mußt du ein\nLeckerbissen sein. Also los, Schätzchen, dein Gesicht will ich zu\nallererst sehen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(": Mein Gott! Wenn er\nsieht, daß es Vera ist, sind wir alle verloren!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("General")]), _vm._v(": Keine Ziererei, mein Kind!\nMarsch, sag' ich, oder ich gebe meiner Wache Auftrag, dir die\nArbeit zu erleichtern. "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page29",
      "title": "a41b/adelheidis"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": Halt, sag' ich, General\nKotemkin!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("General")]), _vm._v(": Wer bist du, Kerl, daß du\nmit so losem Maul zu deinem Vorgesetzten sprichst? ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Alexis nimmt die Maske ab.")]), _vm._v(") Seine kaiserliche\nHoheit, der Zarewitsch!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alle")]), _vm._v(": Der Zarewitsch! Nun ist es\naus!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Präsident")]), _vm._v(": Er wird uns den Soldaten\nausliefern.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(" ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("zu\nVera")]), _vm._v("): Warum hast du mich ihn nicht töten lassen? Vorwärts –\njetzt heißt's auf Leben und Tod kämpfen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Bleib ruhig! Er wird uns\nnicht verraten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": Eine meiner Launen,\nGeneral! Sie wissen, wie mich mein Vater von der Welt absperrt und\nmich im Schloß gefangen hält. Ich müßte mich wirklich zu Tode\nlangweilen, wenn ich nicht mitunter bei Nacht verkleidet\nentschlüpfen und in der Stadt ein kleines, romantisches Abenteuer\nerleben könnte. Ich hab' die guten Leute hier vor ein paar Stunden\ngetroffen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("General")]), _vm._v(": Ganz recht, Hoheit, aber\n–")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": Ich versichere Ihnen, es\nsind ausgezeichnete Schauspieler. Wären Sie zehn Minuten früher\ngekommen, so hätten Sie eine höchst interessante Szene mitansehen\nkönnen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("General")]), _vm._v(": Sind es wirklich\nSchauspieler, mein Prinz?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": Jawohl, und sogar sehr\nehrgeizige Schauspieler. Sie wollen nur vor Majestäten spielen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("General")]), _vm._v(": Meiner Treu, Hoheit, ich\nhatte schon gehofft, einen guten Fang gemacht und Nihilisten\nerwischt zu haben.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": Nihilisten in Moskau,\nGeneral! Wo Sie Polizeichef sind? Ausgeschlossen!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("General")]), _vm._v(": Das sage ich auch immer zu\nIhrem kaiserlichen Herrn Vater. Ich habe aber heute im Staatsrat\ngehört, daß das Weibsbild Vera Saburoff, die Rädelsführerin, "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page30",
      "title": "a41b/adelheidis"
    }
  }), _vm._v(" hier in der\nStadt gesehen worden ist. Das Gesicht des Kaisers wurde weiß wie\nder Schnee draußen. Ich glaube, ich habe nie einen Menschen so\nerschrecken sehen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": Wohl ein gefährliches Weib,\ndie Vera Saburoff?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("General")]), _vm._v(": Das gefährlichste in ganz\nEuropa.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": Haben Sie sie schon jemals\ngesehen, General?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("General")]), _vm._v(": Das schon – vor fünf\nJahren, als ich noch ein simpler Oberst war. Ich erinnere mich\nnoch, Hoheit, wie sie ein gewöhnliches Schankmädchen war. Wenn ich\ndamals gewußt hätte, was aus ihr werden wird, ich hätte sie im\nStraßengraben zu Tode peitschen lassen. Sie ist kein Weibsbild –\nein Teufelsbraten ist sie. In den letzten anderthalb Jahren bin ich\nhinter ihr her, und einmal hab' ich sie in der Umgebung von Odessa\ngesehen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": Wie kam es, daß sie Ihnen\nentwischt ist, General?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("General")]), _vm._v(": Ich war allein, und sie\nschoß eines meiner Pferde gerade in dem Augenblicke nieder, als ich\nsie fassen wollte. Wenn ich sie wieder erwische, will ich meine\nKarten nicht aus der Hand geben. Der Kaiser hat zwanzigtausend\nRubel auf ihren Kopf gesetzt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": Hoffentlich fallen sie\nIhnen zu, General! Aber indessen erschrecken Sie die guten Leute\nhier zu Tode und stören das Spiel. Gute Nacht, General.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("General")]), _vm._v(": Zu dienen, Hoheit – ich\nmöchte aber doch ihre Gesichter sehen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": Nein, General. Das müssen\nSie nicht verlangen. Sie wissen doch, wie es fahrendem Volk gegen\nden Strich geht, sich anstarren zu lassen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("General")]), _vm._v(": Zu dienen, Hoheit. Doch\n–")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(" ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("von\noben herab")]), _vm._v("): General, es sind meine Freunde. Das genügt.\nÜbrigens, General, kein Wort von dem kleinen Abenteuer hier – Sie\nverstehen mich. Ich verlasse mich auf Sie. "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page31",
      "title": "a41b/adelheidis"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("General")]), _vm._v(": Ich werde daran denken,\nmein Prinz. Aber werden wir Sie nicht noch im Schloß sehen? Der\nHofball ist beinahe vorüber, und man erwartet Sie.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": Ich werde kommen – aber\nallein. Nicht vergessen – kein Wort von meinen Schauspielern!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("General")]), _vm._v(": Und von Ihrer hübschen\nZigeunerin – wie, mein Prinz? Ihre hübsche Zigeunerin! Wirklich,\nich möchte sie sehen, bevor ich gehe. Man sieht so schöne Augen\ndurch die Maske. Also, gute Nacht, Hoheit, gute Nacht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(": Gute Nacht, General. (\n"), _c('span', {
    staticClass: "regie"
  }, [_vm._v("General und die Soldaten ab.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(" ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("ihre\nMaske herunterreißend")]), _vm._v("): Gerettet! Durch dich gerettet!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Alexis")]), _vm._v(" ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("ihre\nHand ergreifend")]), _vm._v("): Brüder, wollt ihr mir jetzt vertrauen?\n"), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page32",
      "title": "a41b/adelheidis"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dea5ef4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/chapter3.vue
// module id = 66
// module chunks = 0